<div class="video-preview-container">
  @if (video()) {
  <video [src]="video()" controls preload="metadata" style="max-width: 100%"></video>
  }
</div>